import React from 'react';
import clsx from 'clsx';

import { Table } from '@devexpress/dx-react-grid-material-ui';
import ActionCell from './ActionCell';

import defaultClasses from './RuleExceptionsTable.module.css';

function CellRenderer(cellProps) {
    const classNames = [defaultClasses.cell];
    let Component = Table.Cell;
    switch (cellProps.column.name) {
        case 'action':
            Component = ActionCell;
            break;
        case 'insertTimestamp':
            classNames.push(defaultClasses.numericCell);
            break;
        default:
            // no-op
    }
    return (
        <Component
            {...cellProps}
            className={clsx(classNames)}
        />
    );
}

export default CellRenderer;
